<template>
  <div class="showStatisticsModule vertical_layout screen_spacing" ref="visualScreen">
    <visualization
      class="template_radius"
      ref="liz"
      :screenStatus="screenStatus"
      :containerData="containerData"
      @downLoadEventCallBack="openCallBack"
      @isFullScreenCallBank="isFullScreenCallBank"
    >
      <!-- 左边模块 -->
      <!-- 平台介绍 -->
      <template #platformIntroduction v-if="!tabStatus">
        <div class="visualiModule">
          <div class="loadingScreenMod indexJust" v-if="loading.platformIntroduction">
            <loadingModule />
          </div>
          <projectDetails
            title="平台介绍"
            :platform="platformData"
            v-if="platformData.info && !loading.platformIntroduction"
            @openCallBack="openCallBack"
          ></projectDetails>
        </div>
      </template>
      <!-- 数据总览 -->
      <template #dataScreening v-if="!tabStatus">
        <div class="visualiModule">
          <div class="loadingScreenMod indexJust" v-if="loading.dataScreening">
            <loadingModule />
          </div>
          <div style="height: 100%" class="indexJust" v-else>
            <div style="width: 380px">
              <dataScreening
                :productPie="dataScreeningData"
                :itemGap="12"
                :seriesJson="{
                  richUnameWidth: 100
                }"
                :styleCls="{ height: '130px' }"
                v-if="!loading.dataScreening && dataScreeningData.length > 0"
              ></dataScreening>
              <div class="dataScreeTotal">
                <p>设备数量</p>
                <p>
                  <span>{{ farmInfo.deviceCount }}</span>
                  台
                </p>
              </div>
            </div>
          </div>
        </div>
      </template>
      <!-- 屠宰实时监控 townShipRight -->
      <template #slaughterMeat v-if="!tabStatus">
        <div class="visualiModule" style="box-sizing: border-box; padding: 10px">
          <townShipRight v-if="itemInfo.applicationDeptId == '810508'"></townShipRight>
          <tucaichangRightTopYulin v-else></tucaichangRightTopYulin>
        </div>
      </template>

      <!-- 使用量统计 -->
      <template #usageStatistics v-if="tabStatus">
        <div class="visualiModule">
          <div style="height: 100%" class="indexJust" v-show="!loading.usageStatistics && useList.length > 0">
            <useStatistics :useList="useList" :useColor="useColor" @getList="getLeftList" :key="useList.length"></useStatistics>
          </div>
          <div class="loadingScreenMod indexJust" v-if="loading.usageStatistics">
            <loadingModule />
          </div>
          <div class="loadingScreenMod indexJust" v-if="!loading.usageStatistics && useList.length === 0">
            <noData />
          </div>
        </div>
      </template>
      <!-- 防疫工作排名 -->
      <template #epidemicPreventionRanking v-if="tabStatus">
        <div class="visualiModule">
          <div style="height: 100%; box-sizing: border-box" v-if="!loading.epidemicPreventionRanking && rankList.length > 0">
            <epidemicPreventionRanking
              ref="epidemic"
              :zizhouuserInfo="zizhouuserInfo"
              :level="level"
              :isShowBack="isShowBack"
              :rankList="rankList"
              @peoplePathCallBack="peoplePathCallBack"
            ></epidemicPreventionRanking>
          </div>
          <div class="loadingScreenMod indexJust" v-if="loading.epidemicPreventionRanking">
            <loadingModule />
          </div>
          <div class="loadingScreenMod indexJust" v-if="!loading.epidemicPreventionRanking && rankList.length === 0">
            <noData />
          </div>
        </div>
      </template>
      <!-- 中间模块 -->
      <template #contentMod>
        <div style="height: calc(100% - 40px)">
          <div class="zzryMapModule" v-if="!tabStatus">
            <!-- transform: scale(0.85) translate(-28%, -17%);  -->
            <iframe v-if="mapIframeUrl" :src="mapIframeUrl" height="100%" width="100%" frameborder="0" style="transform-origin: center">
            </iframe>
            <!-- 产业数据 -->
            <!-- <mapModule ref="map" class="mapModule" @change="changeExit" @mapCallBank="mapCallBank" :class="{ zzryMapIndex: mapSts }">
            </mapModule> -->
          </div>
          <div class="epidemicPreventionData" v-if="tabStatus" style="height: 100%">
            <div class="antiepidemicDSearch">
              <el-select
                v-if="options.length > 0"
                v-model="taskId"
                class="selectSeason"
                :popper-append-to-body="false"
                placeholder="请选择"
                @change="changeSelect"
              >
                <el-option
                  class="selectSeason"
                  v-for="item in options"
                  :key="item.id"
                  :label="createSelectDate(item)"
                  :value="item.id"
                  style="display: block"
                >
                  <span>
                    {{ item.taskName.slice(-4) + '\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0' + item.startTime + '--' + item.endTime }}
                  </span>
                </el-option>
              </el-select>
            </div>
            <div class="antiepidemicDMap indexJust" v-show="!loading.vaccineMapLoading" style="height: calc(100% - 65px)">
              <vaccineMap
                ref="vaccineMap"
                :pointList="pointList"
                :countrysideList="countrysideList"
                :taskId="taskId"
                :level="level"
                @nextPart="nextPart"
                :style="vaccineMapStyle"
              ></vaccineMap>
              <div class="antiepidemicDMap indexJust" v-if="loading.vaccineMapLoading">
                <loadingModule />
              </div>
            </div>
          </div>
          <article class="RETURN_POSITION" v-if="tabStatus">
            <!-- 接种畜只数量 -->
            <section v-if="materId" @click="backPrev_parent()">
              <p>返回</p>
            </section>
            <!-- 防疫工作排名 -->
            <section v-if="backLoading" @click="backPrev_path()">
              <p>返回</p>
            </section>
          </article>
          <article class="visualContentBottom" :class="{ visualContentBottomIndex: mapSts }" style="height: 24px">
            <div class="visualContentBottomRelative">
              <!-- <div class="yulinContentBox-type">
                <p class="product" :class="{ products: !tabStatus }" @click="goTo(0)">产业数据</p>
                <p class="preventions" :class="{ prevention: tabStatus }" @click="goTo(1)">防疫数据</p>
              </div> -->
              <div class="yulinContentBox-bottom yulinContentBox-bottoms indexJust">
                <div class="companyinformation">技术支持：陕西微牧云信息科技有限公司</div>
              </div>
            </div>
          </article>
        </div>
      </template>
      <!-- 右边模块 -->
      <!-- 实时监控 -->
      <template #realTimeMonitoring v-if="!tabStatus">
        <div class="visualiModule">
          <div style="height: 100%; box-sizing: border-box; padding: 5px">
            <projectRightTop :screen="requreIsFullScreen()"></projectRightTop>
          </div>
        </div>
      </template>
      <!-- 远程专家 -->
      <template #remoteExperts v-if="!tabStatus">
        <div class="visualiModule">
          <projectExpert></projectExpert>
        </div>
      </template>
      <!-- 内容管理 -->
      <template #dataContent v-if="!tabStatus">
        <div class="visualiModule">
          <projectTics></projectTics>
        </div>
      </template>
      <!-- 接种畜只数量 -->
      <template #inoculatedAnimals v-if="tabStatus">
        <div class="visualiModule" style="padding: 10px; box-sizing: border-box">
          <div class="inoculatedAnimalsBox">
            <div class="inoculatedAnimalsCharts indexJust" v-for="(item, index) in chartsRingList" :key="index">
              <chartsRing
                :ref="`chartsRing${index}`"
                :id-name="`chartsRing${index}`"
                :chartsRingObj="item"
                :livestockName="livestockName(item.livestockType)"
                :legendList="legendList"
              ></chartsRing>
            </div>
          </div>
        </div>
      </template>
      <!-- 疫苗数据统计 -->
      <template #vaccineDataStatistics v-if="tabStatus">
        <div class="visualiModule indexJust" style="padding: 10px; box-sizing: border-box">
          <div class="loadingScreenMod indexJust" v-if="loading.vaccineDataStatistics">
            <loadingModule />
          </div>
          <div class="loadingScreenMod indexJust" v-if="!loading.vaccineDataStatistics && totalChartsList.length === 0">
            <noData />
          </div>
          <totalCharts
            ref="totalCharts"
            :list="totalChartsList"
            :total="leftTotal"
            @change="clickLegend"
            v-if="!loading.vaccineDataStatistics && totalChartsList.length > 0"
          ></totalCharts>
        </div>
      </template>
    </visualization>
    <!-- 加载过程容器 -->
    <div class="loadingContainer indexJust" v-if="containerLoading">
      <loadingModule />
    </div>
  </div>
</template>
  
<script>
import visualization from '@/views/businessModule/visualization.vue';
/* 产业数据 */
const industryData = {
  left: {
    maxHeight: [254, 305, 0],
    module: [
      { className: 'platformIntroduction', title: '平台介绍', moreStatus: false },
      { className: 'dataScreening', title: '数据总览', moreStatus: false },
      { className: 'slaughterMeat', title: '屠宰实时监控', moreStatus: false }
    ],
    className: ['leftTopHeight', 'leftContentHeight', 'leftBottomHeight'],
    surplus: {
      leftTopHeight: { height: 0 },
      leftContentHeight: { height: 0 },
      leftBottomHeight: { height: 0 }
    }
  },
  right: {
    maxHeight: [305, 254, 0],
    module: [
      { className: 'realTimeMonitoring', title: '实时监控', moreStatus: false, event: 'devicesEvent' },
      { className: 'remoteExperts', title: '远程专家', moreStatus: false, event: 'remoteExpertsEvent' },
      { className: 'dataContent', title: '内容管理', moreStatus: false }
    ],
    className: ['rightTopHeight', 'rightContentHeight', 'rightBottomHeight'],
    surplus: {
      rightTopHeight: { height: 0 },
      rightContentHeight: { height: 0 },
      rightBottomHeight: { height: 0 }
    }
  }
};

/* 防疫数量 */
const preventionData = {
  left: {
    maxHeight: [467, 0],
    module: [
      { className: 'usageStatistics', title: '使用量统计', moreStatus: false, event: '' },
      { className: 'epidemicPreventionRanking', title: '防疫工作排名', moreStatus: false, event: '' }
    ],
    className: ['leftTopHeight', 'leftBottomHeight'],
    surplus: {
      leftTopHeight: 0,
      leftBottomHeight: 0
    }
  },
  right: {
    maxHeight: [467, 0],
    module: [
      { className: 'inoculatedAnimals', title: '接种畜只数量', moreStatus: false, event: '' },
      { className: 'vaccineDataStatistics', title: '疫苗数据统计', moreStatus: false, event: '' }
    ],
    className: ['rightTopHeight', 'rightBottomHeight'],
    surplus: {
      rightTopHeight: 0,
      rightBottomHeight: 0
    }
  }
};

const container = {
  top: {
    title: '榆林智慧畜牧大数据平台',
    downStatus: true
  },
  left: industryData.left,
  right: industryData.right,
  _curWidth: 480, // 设计稿宽度
  _leftContent: 'visualScreenLeft',
  _rightContent: 'visualScreenRight'
};
import { url, imgUrl } from './../../../../utils/config';

import loadingModule from '@/views/businessModule/loading1.vue';
import noData from '@/views/businessModule/noData.vue';
import projectDetails from '@/views/businessModule/projectDetails.vue'; // 平台介绍
import dataScreening from '@/views/businessModule/dataScreening.vue'; // 数据统计
import townShipRight from '@/views/businessModule/townShipRight.vue'; // 屠宰实时监控
import tucaichangRightTopYulin from '@/views/businessModule/tucaichangRightTop-yulin.vue';
import projectRightTop from '@/views/businessModule/projectRightTop-yulin.vue'; // 实时监控
import projectExpert from '@/views/businessModule/projectExpert-yulin.vue'; // 远程专家
import projectTics from '@/views/businessModule/projectTics-yulin.vue'; // 内容管理
import vaccineMap from './../component/vaccineMapModule';
import useStatistics from './../component/useStatisticsModule'; // 使用量统计
import epidemicPreventionRanking from '@/views/businessModule/epidemicPreventionRanking-yulin.vue'; // 防疫工作排名
import chartsRing from './../component/chartsRingModule'; // 接种畜只数量
import totalCharts from './../component/totalCharts'; // 疫苗数据统计

import mapModule from '@/views/SmartLivestock/statistics/map/newMap.vue';
import { findDictAppInfo, findSimpleDictInfo } from '@/api/public';

import { zidian } from '@/api/livestocker';
import { getScreenDataOverview } from '@/api/zzry';
import {
  getTaskInfoList,
  areaCoordinateList,
  getPcaCode,
  areaPersCoordinateList,
  getUsageDataLivestockCount,
  getRankingOfEpidemicPrevention,
  getDataLivestockCount,
  selectMaterInfoList,
  findDictList
} from '@/api/statistics';
import { mapColors } from '@/utils/config';
export default {
  data() {
    return {
      screenStatus: false,
      containerData: container,
      // 左侧数据
      // 平台数据
      platformData: {
        title: '',
        info: '',
        textLoading: false
      },
      // 数据总览
      dataScreeningData: [
        {
          name: '养殖户',
          data: 0
        },
        {
          name: '家庭农场',
          data: 0
        },
        {
          name: '养殖企业',
          data: 0
        },
        {
          name: '养殖专业合作社',
          data: 0
        },
        {
          name: '屠宰场',
          data: 0
        }
      ],
      productPieIdnex: 0,
      farmInfo: {},
      // 左下角数据
      itemInfo: null,
      // 使用量统计
      useList: [],
      useColor: '',
      colors: mapColors,
      usageRateOrderingRule: 'desc',
      theRemainingOrderingRule: '',
      // 中间参数
      mapSts: false,
      tabStatus: 0,
      taskId: '',
      options: [],
      isShowBack: false, // 是否显示返回上一级按钮
      // 防疫工作排名
      rankList: [],
      zizhouuserInfo: {},
      // 防疫数据地图搜索
      options: [],
      // 防疫数据地图数据
      pointList: [], // 地图点位数据
      countrysideList: [], // 工作路径数组
      containerMapLoading: false,
      level: JSON.parse(localStorage.info).provincialAndMunicipalLevel,
      deptId: JSON.parse(localStorage.getItem('info')).deptId, // 机构id
      pcode: '', // 行政编码
      // 加载
      loading: {
        platformIntroduction: false,
        dataScreening: false,
        vaccineMapLoading: false,
        usageStatistics: false,
        epidemicPreventionRanking: false,
        vaccineDataStatistics: false
      },
      containerLoading: false,
      // 接种畜只数量
      chartsRingList: [],
      legendList: [],
      dictList: [],
      // 疫苗数据统计
      totalChartsList: [],
      leftTotal: 0,
      materId: '',
      backLoading: false,
      // 设置样式
      vaccineMapStyle: {
        transform: 'scale(0.75)'
        // transform: 'scale(0.75) translate(0, -17%)',
        // 'transform-origin': 'center'
      },
      screenState: false,
      vaccineFullStatus: false,
      // 地图
      mapSts: false,
      mapIframeUrl: ''
    };
  },
  components: {
    visualization,
    loadingModule,
    noData,
    projectDetails,
    dataScreening,
    townShipRight,
    tucaichangRightTopYulin,
    projectRightTop,
    projectExpert,
    projectTics,
    vaccineMap,
    useStatistics,
    epidemicPreventionRanking,
    chartsRing,
    totalCharts,
    mapModule
  },
  created() {
    this.mapSts = false;
    this.zizhouuserInfo = JSON.parse(localStorage.getItem('zizhouuserInfo'));
    this.itemInfo = JSON.parse(localStorage.getItem('itemInfo'));

    // this.init();
  },
  mounted() {
    const itemInfo = JSON.parse(localStorage.getItem('itemInfo'));
    if (itemInfo.screenShowTitle) {
      this.containerData.top.title = itemInfo.screenShowTitle;
    } else this.containerData.top.title = itemInfo.applicationName;

    // 改动
    this.mapIframeData();
    getTaskInfoList({}).then(res => {
      const _data = res.data;
      if (Number(_data.code) === 0) {
        this.options = _data.data || [];
        this.taskId = this.options.find(item => item.status === 0).id;
        this.selectMaterInfoList();
        this.goTo(1);
      }
    });
    this.findDictList();
  },
  methods: {
    // 组装地图数据
    mapIframeData() {
      const userInfo_ZHXM = JSON.parse(localStorage.getItem('userInfo_ZHXM'));
      console.log('userInfo_ZHXM', userInfo_ZHXM);
      const _params = {
        name: userInfo_ZHXM.mapAppAreasName,
        center: userInfo_ZHXM.mapAppAreasPoints.split(','),
        zoom: userInfo_ZHXM.mapAppAreasZoom,
        zooms: userInfo_ZHXM.mapAppAreasZooms
      };
      let urlAdd = '';
      if (url == imgUrl || window.location.href.indexOf('localhost') > -1) {
        urlAdd = 'https://test.vmuyun.com/map/zoom5.html'; // 测试
      } else {
        urlAdd = 'https://vmuyun.com/map/zoom5.html'; // 正式
      }
      this.mapIframeUrl = `${urlAdd}?params=${JSON.stringify(_params)}`;
      console.log(this.mapIframeUrl, 'this.mapIframeUrl');
    },
    init(type) {
      const that = this;
      if (!this.tabStatus) {
        this.itemInfo = JSON.parse(localStorage.getItem('itemInfo'));
        if (this.itemInfo.applicationDeptId == '810508') {
          this.containerData.left.module[2].title = '辖区养殖场/户数统计';
        } else {
          this.containerData.left.module[2].title = '屠宰实时监控';
        }
        this.platformIntroduction();
        this.dataScreenData();
      } else {
        if (!type) {
          this.pcode = '610800';
          this.deptId = JSON.parse(localStorage.info).deptId; // 机构id
          this.level = JSON.parse(localStorage.info).provincialAndMunicipalLevel;
          this.useColor = '';
        }
        if (!type) this.areaCoordinateList();
        that.$nextTick(() => {
          setTimeout(() => {
            that.getUsageDataLivestockCount();
            that.getRankingOfEpidemicPrevention();
            that.getDataLivestockCount();
            that.getTotal();
          }, 500);
        });
      }
    },
    localStorage2() {
      localStorage.setItem('WhetherToTriggerFullScreen', 2);
    },
    upLoadScreen() {
      if (this.requreIsFullScreen()) localStorage.setItem('WhetherToTriggerFullScreen', 2);
    },
    requreIsFullScreen() {
      return this.$refs.liz && this.$refs.liz.$refs.vis ? this.$refs.liz.$refs.vis.isFullScreen : '';
    },
    openCallBack() {
      if (this.requreIsFullScreen()) localStorage.setItem('WhetherToTriggerFullScreen', 2);
    },
    // 查询字典表
    findDictList() {
      findDictList({
        code: 'livestock_type'
      }).then(res => {
        this.dictList = res.data.data[0].children;
      });
    },
    // 切换
    goTo(num) {
      const that = this;
      if (Number(num) === Number(this.tabStatus)) return false;
      this.tabStatus = num;
      if (Number(this.tabStatus)) {
        container.left = preventionData.left;
        container.right = preventionData.right;
        // 防疫数据
        // this.fyInit();
      } else {
        container.left = industryData.left;
        container.right = industryData.right;
      }
      that.upLoadScreen();
      that.isFullScreenCallBank(this.requreIsFullScreen());
      this.containerData = container;
      this.containerLoading = true;
      this.init();
      this.isFullScreenCallBank(this.$refs.liz.isFullScreen);
      setTimeout(() => {
        that.$refs.liz.initScreen();
        that.containerLoading = false;
      }, 500);
    },
    // 获取平台介绍数据
    platformIntroduction() {
      const itemInfo = JSON.parse(localStorage.getItem('userInfo_ZHXM'));
      this.loading.platformIntroduction = true;
      const _params = {
        applicationId: itemInfo.applicationId,
        applicationDeptId: itemInfo.applicationDeptId,
        deptId: itemInfo.deptId,
        infoCode: 'zhxm_screen_introduce'
      };
      findSimpleDictInfo(_params)
        .then(res => {
          const { code, data, msg } = res.data;
          this.loading.platformIntroduction = false;
          if (Number(code) === 0) {
            if (data && data.length > 0) {
              this.platformData.title = data;
              this.platformData.info = data;
              if (this.platformData.title.length > 24 * 5) {
                this.platformData.title = this.platformData.title.slice(0, 24 * 5 - 5) + '......';
                this.platformData.textLoading = true;
              } else this.platformData.textLoading = false;
            }
          }
        })
        .catch(() => {
          this.loading.platformIntroduction = false;
        });
      // zidian({
      //   code: 'xmpt_screen_introduce'
      // })
      //   .then(res => {
      //     let data = res.data.data[0].children;
      //     this.loading.platformIntroduction = false;
      //     data.forEach(item => {
      //       if (item.code == deptId) {
      //         this.platformData.title = item.valueDesc;
      //         this.platformData.info = item.valueDesc;
      //       }
      //     });

      //     if (this.platformData.title.length > 24 * 5) {
      //       this.platformData.title = this.platformData.title.slice(0, 24 * 5 - 5) + '......';
      //       this.platformData.textLoading = true;
      //     } else this.platformData.textLoading = false;
      //   })
      //   .catch(() => {
      //     this.loading.platformIntroduction = false;
      //   });
    },
    // 获取数据总览数据
    dataScreenData() {
      this.loading.dataScreening = true;
      let info = JSON.parse(localStorage.getItem('info'));
      const _params = {
        areaId: info.authProvincesCityAreas,
        applicationId: JSON.parse(localStorage.getItem('itemInfo')).applicationId,
        applicationDeptId: info.authProvincesCityAreas,
        livestockType: JSON.parse(localStorage.getItem('itemInfo')).livestockType,
        deptId: JSON.parse(localStorage.getItem('userInfo_ZHXM')).deptId
      };
      getScreenDataOverview(_params)
        .then(res => {
          const data = res.data;
          this.loading.dataScreening = false;
          if (Number(data.code) === 0) {
            this.farmInfo = data.data || {};
            this.dataScreeningData[0].data = this.farmInfo.normalFarmCount;
            this.dataScreeningData[1].data = this.farmInfo.personFarmCount;
            this.dataScreeningData[2].data = this.farmInfo.companyFarmCount;
            this.dataScreeningData[3].data = this.farmInfo.cooperationFarmCount;
            this.dataScreeningData[4].data = this.farmInfo.butcherCount;
            this.productPieIdnex++;
          }
        })
        .catch(() => {
          this.loading.dataScreening = false;
        });
    },
    // 防疫数据
    // 生成select选中时的样式
    createSelectDate(item) {
      return (
        '\u00a0\u00a0' +
        item.taskName.slice(-4) +
        '\u00a0\u00a0\u00a0\u00a0' +
        item.startTime.split('').join('\u00a0\u00a0\u00a0\u00a0').split('-').join('\u00a0\u00a0')
      );
    },
    // 下钻的回调
    nextPart(pcode, deptId) {
      this.localStorage2();
      this.backLoading = true;
      this.deptId = deptId;
      this.level = '3';
      this.pcode = pcode;
      this.init(1);
    },
    // 搜索
    changeSelect() {
      this.materId = '';
      this.useColor = '';
      this.init();
    },
    // 获取飞线图
    areaCoordinateList() {
      const that = this;
      const _params = {
        deptId: this.deptId,
        // materId: this.materId,
        taskId: this.taskId,
        provincialAndMunicipalLevel: this.level,
        type: 1
      };
      areaCoordinateList(_params, true)
        .then(res => {
          const _data = res.data;
          if (Number(_data.code) === 0) {
            getPcaCode({
              id: this.deptId
            })
              .then(p => {
                this.pcode = p.data.data;
                that.loading.vaccineMapLoading = false;
              })
              .then(() => {
                this.pointList = res.data.data;
                this.backLoading = false;
                this.$nextTick(() => {
                  setTimeout(() => {
                    that.loading.vaccineMapLoading = false;
                  }, 500);
                });
              })
              .catch(() => {
                this.loading.vaccineMapLoading = false;
              });
          } else this.loading.vaccineMapLoading = false;
        })
        .catch(() => {
          this.loading.vaccineMapLoading = false;
        });
      //   areaCoordinateList(_params).then(res => {
      //     const _data = res.data;
      //     if (Number(_data.code) === 0) {
      //       getPcaCode({ id: that.deptId })
      //         .then(element => {
      //           const _elData = element.data;
      //           if (Number(_elData.code) === 0) {
      //             this.pcode = _elData.data;
      //           }
      //         })
      //         .then(() => {
      //           this.pointList = _data.data;
      //         });
      //     }
      //   });
    },
    peoplePathCallBack(val) {
      this.localStorage2();
      this.getPeoplePath(val);
    },
    getPeoplePath(deptId) {
      const that = this;
      areaPersCoordinateList({
        deptId: deptId,
        materId: this.materId,
        taskId: this.taskId,
        type: 1
      }).then(res => {
        const _data = res.data;
        if (Number(_data.code) === 0) {
          this.backLoading = true;
          this.$set(this, 'countrysideList', _data.data);
          this.$nextTick(() => {
            setTimeout(() => {
              that.$refs.vaccineMap.initCountryside();
            }, 500);
          }, 500);
        }
      });
    },
    // 使用量统计
    getUsageDataLivestockCount() {
      getUsageDataLivestockCount({
        taskId: this.taskId,
        deptId: this.deptId,
        materId: this.materId,
        type: 1,
        usageRateOrderingRule: this.usageRateOrderingRule,
        theRemainingOrderingRule: this.theRemainingOrderingRule
      }).then(res => {
        const _data = res.data || [];
        if (Number(_data.code) === 0) {
          this.useList = _data.data || [];
        }
      });
    },
    getLeftList(usageRateOrderingRule, theRemainingOrderingRule) {
      this.usageRateOrderingRule = usageRateOrderingRule;
      this.theRemainingOrderingRule = theRemainingOrderingRule;
      this.getUsageDataLivestockCount();
    },
    // 防疫工作排名
    getRankingOfEpidemicPrevention() {
      const that = this;
      const _params = {
        materId: this.materId,
        deptId: this.deptId,
        taskId: this.taskId,
        pcode: this.pcode,
        provincialAndMunicipalLevel: this.level
      };
      getRankingOfEpidemicPrevention(_params).then(res => {
        const _data = res.data;
        if (Number(_data.code) === 0) {
          this.rankList = _data.data || [];
          if (this.rankList.length > 5) {
            this.$nextTick(() => {
              setTimeout(() => {
                that.$refs.epidemic.initAnimation();
              }, 500);
            }, 500);
          }
        }
      });
    },
    // 获取图例
    selectMaterInfoList() {
      const _params = {
        taskId: this.taskId,
        deptId: this.deptId,
        type: 1
      };
      selectMaterInfoList(_params).then(res => {
        const _data = res.data;
        if (Number(_data.code) === 0) {
          this.leftTotal = _data.data.dataTotals;
          this.legendList = _data.data.dataList.map(item => {
            return {
              id: item.id,
              name: item.materName
            };
          });
          this.areaCoordinateList();
        }
      });
    },
    // 接种蓄只数量
    getDataLivestockCount() {
      const _params = {
        deptId: this.deptId,
        materId: this.materId,
        taskId: this.taskId,
        type: 1
      };
      getDataLivestockCount(_params)
        .then(res => {
          if (res.data.data.length !== 0) {
            let list = [
              {
                livestockNum: 0,
                livestockType: 1,
                materCountList: [
                  {
                    livestockType: 0,
                    materId: 0,
                    materName: '',
                    materNum: 0
                  }
                ]
              },
              {
                livestockNum: 0,
                livestockType: 2,
                materCountList: [
                  {
                    livestockType: 0,
                    materId: 0,
                    materName: '',
                    materNum: 0
                  }
                ]
              },
              {
                livestockNum: 0,
                livestockType: 3,
                materCountList: [
                  {
                    livestockType: 0,
                    materId: 0,
                    materName: '',
                    materNum: 0
                  }
                ]
              },
              {
                livestockNum: 0,
                livestockType: 4,
                materCountList: [
                  {
                    livestockType: 0,
                    materId: 0,
                    materName: '',
                    materNum: 0
                  }
                ]
              },
              {
                livestockNum: 0,
                livestockType: 5,
                materCountList: [
                  {
                    livestockType: 0,
                    materId: 0,
                    materName: '',
                    materNum: 0
                  }
                ]
              },
              {
                livestockNum: 0,
                livestockType: 0,
                materCountList: [
                  {
                    livestockType: 0,
                    materId: 0,
                    materName: '',
                    materNum: 0
                  }
                ]
              }
            ];
            res.data.data.forEach(item => {
              list.forEach((item2, index2) => {
                if (item.livestockType === item2.livestockType && item.materCountList) {
                  list[index2] = item;
                }
              });
            });
            this.chartsRingList = list;
          } else {
            this.chartsRingList = [
              {
                livestockNum: 0,
                livestockType: 1,
                materCountList: [
                  {
                    livestockType: 0,
                    materId: 0,
                    materName: '',
                    materNum: 0
                  }
                ]
              },
              {
                livestockNum: 0,
                livestockType: 2,
                materCountList: [
                  {
                    livestockType: 0,
                    materId: 0,
                    materName: '',
                    materNum: 0
                  }
                ]
              },
              {
                livestockNum: 0,
                livestockType: 3,
                materCountList: [
                  {
                    livestockType: 0,
                    materId: 0,
                    materName: '',
                    materNum: 0
                  }
                ]
              },
              {
                livestockNum: 0,
                livestockType: 4,
                materCountList: [
                  {
                    livestockType: 0,
                    materId: 0,
                    materName: '',
                    materNum: 0
                  }
                ]
              },
              {
                livestockNum: 0,
                livestockType: 5,
                materCountList: [
                  {
                    livestockType: 0,
                    materId: 0,
                    materName: '',
                    materNum: 0
                  }
                ]
              },
              {
                livestockNum: 0,
                livestockType: 0,
                materCountList: [
                  {
                    livestockType: 0,
                    materId: 0,
                    materName: '',
                    materNum: 0
                  }
                ]
              }
            ];
          }
        })
        .then(() => {
          this.chartsRingList.forEach((item, index) => {
            this.$refs[`chartsRing${index}`][0].initMap();
          });
        });
    },
    livestockName(livestockType) {
      return this.dictList.find(item => {
        return item.code == livestockType;
      }).valueDesc;
    },
    // 疫苗数据统计
    getTotal() {
      const that = this;
      const _params = {
        deptId: this.deptId,
        taskId: this.taskId,
        id: this.materId,
        type: 1
      };
      //   this.totalChartsList = [];
      this.loading.vaccineDataStatistics = true;
      selectMaterInfoList(_params)
        .then(res => {
          const _data = res.data;
          this.loading.vaccineDataStatistics = false;
          if (Number(_data.code) === 0) {
            this.leftTotal = _data.data.dataTotals;
            this.totalChartsList = _data.data.dataList.slice(0, 12).map(item => {
              return {
                name: item.materName,
                id: item.id,
                value: item.materNum,
                mixUnit: item.mixUnit,
                itemStyle: {
                  color: this.colors[this.legendList.findIndex(legend => item.materName === legend.name)]
                },
                label: {
                  color: this.colors[this.legendList.findIndex(legend => item.materName === legend.name)],
                  fontSize: '13px',
                  fontWeight: 600,
                  formatter: '{name|{b}}\n{count|{c} ' + item.mixUnit + '}',
                  // formatter: function (params) {
                  //   console.log(params)
                  //   return params.data.name + '\n' + params.data.value + '(' + params.data.mixUnit + ')'
                  // },
                  rich: {
                    name: {
                      fontSize: 15,
                      color: '#fff',
                      align: 'center'
                    },
                    count: {
                      fontSize: 15,
                      padding: [10, 0, 0, 0],
                      align: 'center'
                    }
                  }
                }
              };
            });
            this.$nextTick(() => {
              setTimeout(() => {
                that.$refs.totalCharts.init();
              }, 500);
            });
          }
        })
        .catch(() => {
          this.loading.vaccineDataStatistics = false;
        });
    },
    clickLegend(val) {
      this.materId = val.id;
      this.localStorage2();
      this.init();
      this.useColor = this.colors[val.index];
    },
    // 返回 - 接种畜只数量
    backPrev_parent() {
      this.materId = '';
      this.useColor = '';
      this.localStorage2();
      this.init();
    },
    // 返回 - 防疫工作排名
    backPrev_path() {
      //   this.selectMaterInfoList();
      if (this.countrysideList.length !== 0) {
        this.countrysideList = [];
      } else {
        this.$refs.vaccineMap.backMap();
        this.pcode = '610800';
        this.deptId = JSON.parse(localStorage.info).deptId; // 机构id
        this.level = JSON.parse(localStorage.info).provincialAndMunicipalLevel;
        this.backLoading = false;
      }
      this.localStorage2();
      this.init(1);
    },
    isFullScreenCallBank(val) {
      if (val) {
        this.vaccineMapStyle = {
          transform: 'scale(0.8)'
          //   transform: 'scale(0.8) translate(0, 0)',
          //   'transform-origin': 'center'
        };
      } else {
        this.vaccineMapStyle = {
          transform: 'scale(0.7)'
          //   transform: 'scale(0.7) translate(0, -17%)',
          //   'transform-origin': 'center'
        };
      }
    },
    screenchange(val, sts) {
      const that = this;
      that.screenState = val;
      this.vaccineFullStatus = sts;
      setTimeout(() => {
        that.vaccineBegin();
      }, 200);
    },
    vaccineBegin() {
      const that = this;
      that.vaccineFullStatus = true;
      that.getTotal();
      //   this.$nextTick(() => {
      //     setTimeout(() => {
      //       if (that.$refs.totalCharts) that.$refs.totalCharts.init();
      //     }, 500);
      //   }, 500);
    },
    // 地图事件
    mapCallBank(val) {
      this.mapSts = val;
    },
    // 地图回调事件
    changeExit(val) {}
  }
};
</script>
  
<style lang="scss">
* {
  margin: 0;
  padding: 0;
}
</style>
<style lang="scss" scoped>
.visualiModule {
  height: 100%;
}
.showStatisticsModule {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
  &.showStatisticsModuleFixed {
    position: fixed;
    top: 0;
    left: 0;
  }
  .showStatisticsModuleReative {
    width: 100%;
    height: 100%;
    position: relative;
    z-index: 1;
  }
}

/* 中间模块 */
.visualScreenContent {
  .zzryMapModule {
    height: 100%;
    position: relative;
  }

  .visualContentBottom {
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 1800;
    height: 156px;
    .visualContentBottomRelative {
      height: 100%;
      position: relative;
    }
    &.visualContentBottomIndex {
      z-index: 1700;
    }
    .yulinContentBox {
      &-type {
        width: 392px;
        height: 117px;
        display: flex;
        font-size: 16px;
        color: #ffffff;
        text-align: center;
        cursor: pointer;
        padding-bottom: 15px;
        box-sizing: border-box;
        margin: 0 auto;
        p {
          margin: 0;
          padding: 0;
        }
        .preventions {
          margin-left: 60px;
          width: 116px;
          height: 116px;
          background: url('../../../../../static/large/prevention.png') no-repeat;
          color: #fff;
          text-align: center;
          padding-top: 75px;
          box-sizing: border-box;
          &.prevention {
            background: url('../../../../../static/large/prevention-active.png') no-repeat;
            color: #e7ca4c;
          }
        }
        .product {
          margin-left: 60px;
          width: 116px;
          height: 116px;
          background: url('../../../../../static/large/product.png') no-repeat;
          text-align: center;
          color: #fff;
          padding-top: 75px;
          box-sizing: border-box;
          &.products {
            background: url('../../../../../static/large/product-active.png') no-repeat;
            text-align: center;
            color: #e7ca4c;
          }
        }
      }
      &-bottom {
        max-width: 800px;
        height: 24px;
        background: url('../../../../../static/large/bottom.png') no-repeat;
        background-size: 100% 100%;
        margin: 0 auto;
        font-size: 13px;
        color: white;
      }
    }
  }
}

.dataScreeTotal {
  width: 321px;
  font-size: 15px;
  color: white;
  margin: 0 auto;
  height: 64px;
  background: url('../../../../../static/large/project-count.png');
  background-size: 100% 100%;
  box-sizing: border-box;
  padding: 27px 0 0 80px;
  display: flex;
  p {
    display: inline-block;
    span {
      font-size: 24px;
    }
    &:first-of-type {
      padding-top: 5px;
    }
    &:last-of-type {
      flex: 1;
      text-align: right;
      padding-right: 65px;
    }
  }
}
</style>

<style>
.indexJust {
  display: flex;
  display: -ms-flexbox;
  -webkit-display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-justify-content: center;
  align-items: center;
}
</style>

<style lang="scss">
/* 防疫地图 */
.antiepidemicDSearch {
  width: 80%;
  margin: 0 auto;
  text-align: center;
  margin-top: 16px;
  position: relative;
  z-index: 2000;
  .selectSeason {
    display: inline-block;
    max-width: 580px;
    width: 100%;
    .el-input__inner {
      //border: 1px solid #1CDFF5;
      border: none;
      border-radius: 4px;
      height: 50px;
      line-height: 50px;
      background-color: rgba(0, 0, 0, 0);
      font-size: 24px;
      color: #ffffff;
      //background-color: red;
      // background-image: url('../../../../static/images/bg_select.png');
      background-image: url('../../../../../static/large/input-bg.png');
      background-repeat: no-repeat;
      background-size: contain;
    }

    .el-input__suffix {
      width: 38px;
    }

    .el-icon-arrow-up:before {
      content: '\e78f';
      color: #1d5fd1;
    }

    .el-select-dropdown {
      //top: 40px !important;
      background-color: rgba(0, 27, 25, 0.6);
      border: 2px solid #1d5fd1;
      text-align: center;

      .el-scrollbar {
        .el-select-dropdown__wrap {
          .el-scrollbar__view {
            .el-select-dropdown__item {
              color: #ffffff;
              font-size: 24px;
            }

            .selected,
            .hover {
              background: #1d5fd1;
              color: #000000;
            }
          }
        }
      }

      .popper__arrow {
        border-bottom-color: transparent;
      }

      .popper__arrow::after {
        border-bottom-color: transparent;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.inoculatedAnimalsBox {
  height: 100%;
}

.inoculatedAnimalsCharts {
  width: 33.3%;
  float: left;
  height: 50%;
}

.loadingContainer {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  background-color: #0f2650;
  opacity: 0.98;
  z-index: 5000;
}

.RETURN_POSITION {
  position: absolute;
  bottom: 80px;
  right: 25px;
  z-index: 2000;
  section {
    display: inline-block;
    width: 65px;
    height: 30px;
    border: 1px solid #1d5fd1;
    border-radius: 4px;
    text-align: center;
    line-height: 30px;
    cursor: pointer;
    margin: 0 5px;
    font-size: 14px;
    color: #1d5fd1;
    p {
      cursor: pointer;
      margin: 0;
      padding: 0;
    }
  }
}

.zzryMapModule {
  .mapModule {
    height: 100%;
    position: relative;
    z-index: 1700;
    &.zzryMapIndex {
      z-index: 1800;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/SmartLivestock/statistics/module/firstTemplate.vue